export default __webpack_public_path__ + "static/media/SFactura.843a8fba.svg";